<template>
  <div>
    <div class="card modal-card-border infoWindowMap">
      <div class="card-content">
        <div>
          <div class="columns">
            <div class="column is-9">
              <h1 class="is-5">
                <span class="subtitle">
                  Code reseau <span class="has-text-info">{{reseau.code}}</span>
                </span>
              </h1>
            </div>
          </div>
          <div class="columns detail-component">
            <div class="column is-5">
              <img :src="reseau.urlPhoto"
                   v-if="reseau.urlPhoto"
                   class="image is-240x240">
              <img v-else class="image is-240x240" src="@/assets/default-placeholder.png">
            </div>
            <div class="column is-8">
              <h1 class="subtitle is-6 information-title">Informations</h1>
              <br>
              <div class="column is-8">
                <p class="information">Nom du réseau</p>
                <span>{{reseau.libelle}}</span>
              </div>
              <div class="columns">
                <div class="column is-6">
                  <p class="information">Nbre de faces</p>
                  <span>{{reseau.nbFaces}}</span>
                  <br>
                  <p class="information">Ville</p>
                  <span>{{reseau.ville}}</span>
                  <br>
                </div>
                <div class="column is-6">
                  <p class="information">Format</p>
                  <span>{{reseau.format}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'info-window-reseau',
  props: ['reseau'],
  data() {
    return {};
  },
};

</script>

<style scoped>
.distance{
  margin-left: 0px;
  margin-top: -33px;
}

.columns{
  margin:0px;
}

  .information {
    font-size:14px;
  }

  .information-title {
    margin-left:10px;
    margin-bottom:0;
  }

.arrow {
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/infoWindowReseaux.vue